import { FC } from 'react';
import cn from 'classnames';
import CircularBar from '@components/new/CircularBar/CircularBar';
import './CircularBarWithLabel.scss';

interface CircularBarWithLabelProps {
    percentage: number;
    id: string;
    title: string;
    averageValue?: number;
    valueClassName?: string;
}

const CircularBarWithLabel: FC<CircularBarWithLabelProps> = ({ percentage, id, title, averageValue, valueClassName }) => {
    return (
        <div className="CircularBarWithLabel">
            <CircularBar percentage={percentage} id={id} className={valueClassName} />
            <div className="CircularBarWithLabel__description">
                <div className={cn("CircularBarWithLabel__total", valueClassName)}>{percentage}%</div>
                <div className="CircularBarWithLabel__title">{title}</div>
                {averageValue != null && (
                    <div className={cn("CircularBarWithLabel__avg", valueClassName)}>vs. segment avg: {averageValue}%</div>
                )}
            </div>
        </div>
    );
};

export default CircularBarWithLabel;
